import { SENTRY_COMPONENT_SCRIPT_DSN } from '../../../common/constants/sentry-dsn';
import { LIB_VERSION } from '../../../version';
export const SENTRY_CONFIG_APP = {
    dsn: SENTRY_COMPONENT_SCRIPT_DSN,
    config: {
        environment: `wix-comments-ooi-client-${process.env.NODE_ENV}`,
    },
    tags: {
        release: LIB_VERSION,
    },
};
//# sourceMappingURL=sentry-error-boundary-config.js.map